


import axiosInstance from '@/lib/axios'; // Your configured axiosInstance instance

export async function initiateMatchQueue_1v1(payload) {
    try {
        const response = await axiosInstance.post('/match/queue1v1', payload);
        return response.data; // success
    } catch (error) {
        alert(error.response?.data?.detail);  // shows "Your credit score is too low to join the queue"
    }
}




export async function getMatchQueue_1v1() {


    const response = await axiosInstance.get('/match/queue1v1');


    return response;
}



export async function cancelMatchQueue_1v1() {

    const response = await axiosInstance.delete('/match/queue1v1');
    return response.data;
}




